export default {
  api_r_user_module_survey_getModuleData: {
    path: 'm/survey/get-module-data/',
  },
  api_r_user_module_survey_getPermissions: {
    path: 'm/survey/get-permissions/',
  },
};
